import { defineMessages } from 'react-intl';

const fields = defineMessages({
    bookingReference: {
        id: 'retrieveSelfCheckIn-formField-bookingReference',
        defaultMessage: 'Booking Reference',
    },
    lastName: {
        id: 'retrieveSelfCheckIn-formField-lastName',
        defaultMessage: 'Last Name',
    },
    enterLastName: {
        id: 'retrieveSelfCheckIn-formField-enterLastName',
        defaultMessage: 'Please enter last name',
    },
    enterBookingReference: {
        id: 'retrieveSelfCheckIn-formField-enterbookingreference',
        defaultMessage: 'Please enter booking reference',
    },
});

const buttons = defineMessages({
    startCheckInNow: {
        id: 'retrieveSelfCheckIn.buttons.startCheckInNow',
        defaultMessage: 'Start Check In Now',
    },
    continue: {
        id: 'retrieveSelfCheckIn.buttons.continueButton',
        defaultMessage: 'Save & Continue',
    },
});

const content = defineMessages({
    modalInfo: {
        id: 'retrieveSelfCheckIn.content.modalInfo',
        defaultMessage: `Please make sure your Booking reference has a suffix (If you don't know the suffix of your booking, please try "-1").
            You can also use your Agent reference in case you don’t have Booking reference handy.`,
    },
    modalInfoCA: {
        id: 'retrieveSelfCheckIn.content.modalInfoCA',
        defaultMessage: `Please make sure your Booking reference has a suffix (If you don't know the suffix of your booking, please try "-1").
            You can also use your Tour Operator reference in case you don’t have Booking reference handy.`,
    },
    thanksForChoosing: {
        id: 'retrieveSelfCheckIn.content.ThanksForChoosing',
        defaultMessage: 'Thanks for choosing to travel with',
    },
    thl: {
        id: 'retrieveSelfCheckIn.content.Thl',
        defaultMessage: 'thl',
    },
    weNeed: {
        id: 'retrieveSelfCheckIn.content.WeNeed',
        defaultMessage:
            'We need to get a few quick details before your arrival to prepare and get you on the road smoothly and quickly.',
    },
    toGetStarted: {
        id: 'retrieveSelfCheckIn.content.ToGetStarted',
        defaultMessage:
            'To get started, enter your booking reference and last name below. You can find these on your booking confirmation.',
    },
    usOutstandingBalance: {
        id: 'retrieveSelfCheckIn.content.usOutStandingBalance',
        defaultMessage:
            'Please note, when completing the self check in process, you will be prompted to pay any outstanding balances owing on your booking.  You should complete the check in process 14 days before you are due to travel.',
    },
    welcomeTo: {
        id: 'retrieveSelfCheckIn.content.welcomeTo',
        defaultMessage: "Ready to Hit the Road? Let's Check You In!",
    },
    welcomeToAuNz: {
        id: 'retrieveSelfCheckIn.content.welcomeToAuNz',
        defaultMessage: "Ready to Hit the Road? Let's Check You In.",
    },
    days: {
        id: 'retrieveSelfCheckIn.content.days',
        defaultMessage: '5 days',
    },
    daysUS: {
        id: 'retrieveSelfCheckIn.content.daysUS',
        defaultMessage: '30 days',
    },
    checkInOpens: {
        id: 'retrieveSelfCheckIn.content.checkInOpens',
        defaultMessage:
            'Your adventure starts here! Online Check-In opens <b>{days} days before pick-up</b>, and it’s the best way to prepare for your departure and to save time at the branch.',
    },
    checkInOpensAuNz: {
        id: 'retrieveSelfCheckIn.content.checkInOpensAuNz',
        defaultMessage:
            'Online Check-In is the best way to prepare for your departure and aims to save you time at the branch.',
    },
    headsUpBoldText: {
        id: 'retrieveSelfCheckIn.content.headsUpBoldText',
        defaultMessage: 'Heads up:',
    },
    headsUp: {
        id: 'retrieveSelfCheckIn.content.headsUp',
        defaultMessage:
            '<b>{headsUpBoldText}</b> Online Check-In will take around {minutes} minutes to complete and must be completed before arriving at the branch.',
    },
    beforePickUp: {
        id: 'retrieveSelfCheckIn.content.beforePickUp',
        defaultMessage:
            'before pick-up and all Guests must complete check-in before arriving at our station.',
    },
    duringCheckIn: {
        id: 'retrieveSelfCheckIn.content.duringCheckIn',
        defaultMessage: "What you'll need to do:",
    },
    contactDetails: {
        id: 'retrieveSelfCheckIn.content.contactDetails',
        defaultMessage: '<b>Complete your contact details</b>.',
    },
    licenceDetails: {
        id: 'retrieveSelfCheckIn.content.licenceDetails',
        defaultMessage:
            "<b>Enter driver's licence information</b> for all drivers.",
    },
    additionalDrivers: {
        id: 'retrieveSelfCheckIn.content.additionalDrivers',
        defaultMessage: '<b>Add any additional drivers</b>.',
    },
    demoVideos: {
        id: 'retrieveSelfCheckIn.content.demoVideos',
        defaultMessage:
            '<b>Watch our Safe Driving video</b> to help you prepare for your trip.',
    },
    demoVideosUK: {
        id: 'retrieveSelfCheckIn.content.demoVideosUK',
        defaultMessage:
            '<b>Watch our Motorhome Demonstration & Safe Driving video</b> to help you prepare for your trip.',
    },
    demoVideosUSCA: {
        id: 'retrieveSelfCheckIn.content.ca.demoVideosUSCA',
        defaultMessage:
            '<b>Watch our RV Demonstration & Safe Driving video</b> to help you prepare for your trip.',
    },
    travelExtras: {
        id: 'retrieveSelfCheckIn.content.travelExtras',
        defaultMessage: '<b>Choose Travel Extras</b> to enhance your holiday.',
    },
    travelExtrasUSCA: {
        id: 'retrieveSelfCheckIn.content.travelExtrasUSCA',
        defaultMessage:
            '<b>Choose Travel Extras</b> to enhance your RV vacation.',
    },
    outstanding: {
        id: 'retrieveSelfCheckIn.content.outstanding',
        defaultMessage: '<b>Settle any outstanding balances</b>.',
    },
    insurancePolicy: {
        id: 'retrieveSelfCheckIn.content.insurancePolicy',
        defaultMessage:
            '<b>Review & accept our important documents</b> like the Rental Agreement.',
    },
    insurancePolicyUSCA: {
        id: 'retrieveSelfCheckIn.content.insurancePolicyUSCA',
        defaultMessage:
            '<b>Review & accept our important documents</b> like the Rental Agreement and Insurance Policy.',
    },
    insurancePolicyUK: {
        id: 'retrieveSelfCheckIn.content.insurancePolicyUK',
        defaultMessage:
            '<b>Review & accept our important documents</b> like the Rental Agreement and Insurance Policy.',
    },
    subTextUs: {
        id: 'retrieveSelfCheckIn.content.subTextUs',
        defaultMessage:
            '<b>To get started, enter your booking reference (including the “–“ it will look like ABC123456-1) and last name below. You can find these on your booking confirmation.</b>',
    },
    subTextCa: {
        id: 'retrieveSelfCheckIn.content.subTextCa',
        defaultMessage:
            'Guests must fully complete Online Check in for all selections to be saved, Note: Pick up and Drop off times, will be released unless the check in process is completed.',
    },
    tip: {
        id: 'retrieveSelfCheckIn.content.tip',
        defaultMessage:
            '<b>Tip</b>: Make sure you complete every step of Online Check-in so your selections are saved.',
    },
    importantInfo: {
        id: 'retrieveSelfCheckIn.content.importantInfo',
        defaultMessage:
            '<b>Important</b>: If check-in isn’t completed, your pick-up and drop-off times selected will be released.',
    },
});

const placeHolders = defineMessages({
    lastName: {
        id: 'retrieveSelfCheckIn.placeHolders.lastName',
        defaultMessage: 'E.g. Smith',
    },
    bookingReference: {
        id: 'retrieveSelfCheckIn.placeHolders.bookingReference',
        defaultMessage: 'E.g. ABC123456-1',
    },
});

const error = defineMessages({
    unableToRetrieve: {
        id: 'retrieveSelfCheckIn.error.unableToRetrieve',
        defaultMessage: 'Unable to retrieve your booking?',
    },
    tryThese: {
        id: 'retrieveSelfCheckIn.error.tryThese',
        defaultMessage: 'Try these trouble shooting suggestions:',
    },
    bookingReferenceApplicable: {
        id: `booking-reference-applicable`,
        defaultMessage: `• Check the booking reference (and suffix if
            applicable).`,
    },
    bookingSuffix: {
        id: 'retrieveSelfCheckIn.error',
        defaultMessage: `• If you don't know the suffix of your booking, please try "-1"`,
    },
    lastNameConfirmation: {
        id: 'retrieveSelfCheckIn.error.lastNameConfirmation',
        defaultMessage: `• Check that the spelling of your last name matches
        the booking confirmation.`,
    },
    pleaseContact: {
        id: 'retrieveSelfCheckIn.error.pleaseContact',
        defaultMessage: `• Please contact us using below details.`,
    },
    pleaseContactUs: {
        id: 'retrieveSelfCheckIn.error.pleaseContactUs',
        defaultMessage: `Please contact us using below details.`,
    },
    someThingWrong: {
        id: 'retrieveSelfCheckIn.error.someThingWrong',
        defaultMessage: `Oops, something went wrong.`,
    },
    makeChanges: {
        id: 'retrieveSelfCheckIn.error.makeChanges',
        defaultMessage: `If you would like to make any changes, please contact us using below details for assistance.`,
    },
    makeChangesWebChat: {
        id: 'retrieveSelfCheckIn.error.makeChangesWebChat',
        description: 'makeChangesWebChat',
        defaultMessage: `If you would like to make any changes, please contact us via Web Chat or the phone number below for assistance.`,
    },
    conflict: {
        id: 'retrieveSelfCheckIn.error.conflict',
        defaultMessage:
            'Looks like there is a change on your booking. Please contact us using the below details.',
    },
    conflictWithLink: {
        id: 'retrieveSelfCheckIn.error.conflictWithLink',
        defaultMessage:
            'Looks like there is a change on your booking. Please contact us <a>here</a> or using the below details.',
    },
    tooEarlyToStartSelfCheckIn: {
        id: 'retrieveSelfCheckIn.error.tooEarlyToStartSCI',
        defaultMessage: 'Oops you are too early!',
    },
    tooEarlyToStartSelfCheckInDescription: {
        id: 'retrieveSelfCheckIn.error.tooEarlyToStartSCIDescription',
        defaultMessage: 'Check in opens {days} before your pick up date.',
    },
});

const success = defineMessages({
    registrationCompleted: {
        id: 'retrieveSelfCheckIn.success.registrationCompleted',
        defaultMessage: `Registration for this rental has already been
         completed.`,
    },
});

const recaptcha = defineMessages({
    disclaimer: {
        id: 'retrieveSelfCheckIn.recaptcha.disclaimer',
        defaultMessage: 'This site is protected by reCAPTCHA and the Google',
    },
    privacyPolicy: {
        id: 'retrieveSelfCheckIn.recaptcha.privacyPolicy',
        defaultMessage: 'Privacy Policy',
    },
    termsOfService: {
        id: 'retrieveSelfCheckIn.recaptcha.termsOfService',
        defaultMessage: 'Terms of Service',
    },
    apply: {
        id: 'retrieveSelfCheckIn.recaptcha.apply',
        defaultMessage: 'apply.',
    },
});

const retrieveSelfCheckInMessages = {
    fields,
    buttons,
    content,
    placeHolders,
    error,
    success,
    recaptcha,
};

export default retrieveSelfCheckInMessages;
